<script lang="ts">
  import Modal from '$lib/components/styled/Modal.svelte';
  import {saveGojiraFlow} from '$lib/flows/saveGojiraFlow';
  import {allGojiras, currentGojira, currentGojiraState} from '$lib/state/gojiras';
  import {currentSettings} from '$lib/state/settings';

  function randomize() {
    for (let i = 0; i < $currentSettings.gojiraCardSets.length; i++) {
      const numChoices = $currentSettings.gojiraCardSets[i].set.length;
      $currentGojira.attributes[i] = Math.floor(Math.random() * numChoices);
    }
  }
</script>

<div>
  <h1 class="font-black text-4xl">Your Gojira</h1>
  <span class="m-2 inline-block">Name: <input class="bg-slate-200" bind:value={$currentGojira.name} type="text" /></span
  >
  {#if (!$currentGojiraState.inList || $currentGojiraState.changed) && $currentGojiraState.valid}
    <button class="border-2 border-black p-2" on:click={() => saveGojiraFlow.save()}>Save</button>
    {#if $currentGojiraState.inList}
      <button class="border-2 border-black p-2" on:click={() => allGojiras.reset()}>Reset</button>
    {/if}
  {/if}
</div>

<h2 class="font-bold text-xl">
  Gojira cards <button class="border-2 border-black p-2" on:click={() => randomize()}>RNG</button>
</h2>
{#each $currentGojira.attributes as attributeValue, attribute}
  {attribute}
  <input
    bind:value={$currentGojira.attributes[attribute]}
    type="number"
    class={`bg-slate-200 ` +
      ($currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]] !== undefined
        ? ''
        : ' text-red-500')}
  />
  {#if $currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]]}
    attack:{$currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]][0].attack}
    defense:{$currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]][0].defense}
    strength:{$currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]][0].strength}
    protection:{$currentSettings.gojiraCardSets[attribute].set[$currentGojira.attributes[attribute]][0].protection}
  {/if}
  <br />
{/each}

<hr />
<hr class="border border-black" />
<hr />

<h2 class="font-bold text-xl">Base cards</h2>
<input
  bind:value={$currentGojira.base}
  type="number"
  class={`bg-slate-200 ` + ($currentSettings.baseCardSets[$currentGojira.base] !== undefined ? '' : ' text-red-500')}
/>

{#if $currentSettings.baseCardSets[$currentGojira.base]}
  {#each $currentSettings.baseCardSets[$currentGojira.base] as _, j}
    attack {$currentSettings.baseCardSets[$currentGojira.base][j].attack}
    defense {$currentSettings.baseCardSets[$currentGojira.base][j].defense}
    strength {$currentSettings.baseCardSets[$currentGojira.base][j].strength}
    protection {$currentSettings.baseCardSets[$currentGojira.base][j].protection}
    <br />
  {/each}
{/if}

<hr />
<hr class="border border-black" />
<hr />

<h2 class="font-bold text-xl">Otther Gojiras</h2>

<div>
  {#each Object.values($allGojiras.list) as fullGojira}
    <button class="border-black border-2 p-2 m-2" on:click={() => allGojiras.use(fullGojira.gojira.name)}>
      {fullGojira.gojira.name}
    </button>
  {/each}
</div>

<button class="border-black border-2 p-2 m-2" on:click={() => allGojiras.clear()}> CLEAR </button>

{#if $saveGojiraFlow.step === 'CONFIRM'}
  <Modal on:close={() => saveGojiraFlow.cancel()}>
    {#if $saveGojiraFlow.message}
      <p>{$saveGojiraFlow.message}</p>
    {/if}
    <button class="border-2 border-black p-2 m-2" on:click={() => saveGojiraFlow.confirm()}>confirm</button>
  </Modal>
{:else if $saveGojiraFlow.step === 'BLOCKER'}
  <Modal on:close={() => saveGojiraFlow.cancel()}>
    {#if $saveGojiraFlow.message}
      <p>{$saveGojiraFlow.message}</p>
    {/if}
    <button class="border-2 border-black p-2 m-2" on:click={() => saveGojiraFlow.cancel()}>OK</button>
  </Modal>
{/if}
